import React from 'react'

//components
import PrimarySmallButton from '../Button/Custom/PrimarySmallButton'

function StepsCard({ step, title, description, buttonName }) {
    return (
        <div>
            <div className='flex flex-col bg-white w-280 p-24 space-y-16 shadow-lg blur-0'>
                <div className='space-y-5'>
                    <div className='text-12 text-gray-600'>
                        {step}
                    </div>
                    <div className='flex flex-col space-y-16'>
                        <div className='text-22 font-bold text-16'>
                            {title}
                        </div>
                        <div className='text-16 text-gray-500'>
                            {description}
                        </div>
                    </div>
                </div>
                {buttonName && (        
                    <div>
                    <PrimarySmallButton
                        name={buttonName}
                    />
                </div>
                )}
            </div>
        </div>
    )
}

export default StepsCard